// Главный экспорт для системы кеширования изображений
export { ImageCacheService } from './ImageCacheService.js';
export { ImageCacheDB } from './ImageCacheDB.js';
export { CacheManager } from './CacheManager.js';
export { SizeEstimator } from './SizeEstimator.js';
export { DOMCacheHandler } from './DOMCacheHandler.js';
export { AlternativeCacheMethods } from './AlternativeCacheMethods.js';

// Создаем глобальный экземпляр для обратной совместимости
import { ImageCacheService } from './ImageCacheService.js';
export const imageCacheService = new ImageCacheService();

// Экспортируем отдельные экземпляры для прямого использования
import { ImageCacheDB } from './ImageCacheDB.js';
import { CacheManager } from './CacheManager.js';
export const imageCacheDB = new ImageCacheDB();
export const cacheManager = new CacheManager();
